import React from 'react';
import Heading from '../../heading/heading';
import Footer from '../../footer/footer';
import './aboutus.css';
import GetDirection from '../../get-direction/getdirection';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhoneAlt} from '@fortawesome/free-solid-svg-icons';



function Aboutus() {
  
  window.document.title = "SPS Land Promoters | Contact Us "

  return (
    <div>
      <Heading />
        <div className='aboutus_page_heading text-center'>About us</div>
        <p className="aboutus_page_content ">SPS land promoters are headquartered in theni-veerapandi. We are Provide Best Approval Plots And Home Loan Services For Your Dream House. And also we are providing construction plans And solutions. We have the best quality DTCP approval plots. We have well-skilled workers and Engineers. We will Provide Starting to end all of the construction plans, solutions, workers, Engineers. feel free to contact us for more information.</p>

        <div className="aboutus_page_founder_container ">
             <div className='aboutus_page_founder_heading'>Founder &#38; CEO</div>
             <hr className='aboutus_page_founder_divider' />
             <div className='aboutus_page_founder_name'>A. Santhanam</div>
        </div>
        {/* Joint directors */}
        {/* one */}

     <div className='aboutus_page_jd_heading'>Joint Directors</div>
        <hr className='aboutus_page_founder_divider' />

        <div className='aboutus_directors_container '>
           <div className='aboutus_director'>
             <div className='aboutus_director_name'>C.Suresh</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+919025709558" className="director_number">
               <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9025709558</a>
           </div>

           <div className='aboutus_director'>
             <div className='aboutus_director_name'>M. Murugan</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+919345992923" className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9345992923</a>
           </div>
           <div className='aboutus_director'>
             <div className='aboutus_director_name'>G. 
             Thiyagarajan  </div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+917639878327"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               7639878327</a>
           </div>

           </div>
           {/* two*/}
        <div className='aboutus_directors_container '>

           <div className='aboutus_director'>
             <div className='aboutus_director_name'>R. Suresh</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+916379563161"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               6379563161</a>
           </div>
           <div className='aboutus_director'>
             <div className='aboutus_director_name'>M. Venkateshwaran</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+919629596857"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9629596857</a>
           </div>
           <div className='aboutus_director'>
             <div className='aboutus_director_name'>P. BalaMurugan</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+918608873356"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               8608873356</a>
           </div>

  </div>
{/* three */}

  <div className='aboutus_directors_container '>

           <div className='aboutus_director'>
             <div className='aboutus_director_name'>K. Jayachandran</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+919865215151"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9865215151</a>
           </div>

           <div className='aboutus_director'>
             <div className='aboutus_director_name'>S. Sountharapandi</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+919365849776"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9365849776</a>
           </div>

           <div className='aboutus_director'>
             <div className='aboutus_director_name'>V. Gunasekaran</div>
             <div className='aboutus_director_position'>Joint Director</div>
             <a href="tel:+919952896557"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9952896557</a>
           </div>
          </div>
           {/*four  */}
  <div className='aboutus_directors_container '>

<div className='aboutus_director'>
  <div className='aboutus_director_name'>M. Anbarasan</div>
  <div className='aboutus_director_position'>Joint Director</div>
  <a href="tel:+919865415210"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
    9865415210</a>
</div>

<div className='aboutus_director'>
  <div className='aboutus_director_name'>S. Vijayakannan</div>
  <div className='aboutus_director_position'>Joint Director</div>
  <a href="tel:+918248780036"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
    8248780036</a>
</div>


           <div className='aboutus_director'>
             <div className='aboutus_director_name'>M. Saravanakumar &#38; S. Praveen Kumar</div>
             <div className='aboutus_director_position'>Marketing Managment</div>
             <a href="tel:+918608636671"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               8608636671</a>
             <div>
             <a href="tel:+919080508722"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9080508722</a>
             </div>
           </div>
         </div>

     {/* Deputy director */}

        <div className='aboutus_page_jd_heading'>Deputy Directors</div>
        <hr className='aboutus_page_founder_divider' />

      <div className='Deputy_director_container'>
          
          <div className='aboutus_Deputy_director'>
             <div className='aboutus_Deputy_director_name'>M. Kuppusamy</div>
             <div className='aboutus_Deputy_director_position'>Deputy Director</div>
             <a href="tel:+919025805730"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9025805730</a>
           </div>

           <div className='aboutus_Deputy_director'>
             <div className='aboutus_Deputy_director_name'>R. Nagaraj</div>
             <div className='aboutus_Deputy_director_position'>Deputy Director</div>
             <a href="tel:+919488959415"  className="director_number">
             <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
               9488959415</a>
           </div>
      </div>

{/* marketing teams */}
<div className='aboutus_page_jd_heading'>Marketing Team Leaders</div>
        <hr className='aboutus_page_founder_divider' />

      <div className='abouttus_marketing_team_container'>

<div className='aboutus_directors_container'>
  
  <div className='aboutus_director'>
  <div className='aboutus_director_name'>B. Kannan</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+917603859369"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  7603859369</a>
</div>

{/* two*/}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>V. Prabhu</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+918248994685"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  8248994685</a>
</div>


{/* three*/}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>S. Arun Pandian</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+918675343736"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  8675343736</a>
</div>

</div>
<div className='aboutus_directors_container'>

{/* 4*/}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>S. Iyyappan</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919159658079"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9159658079</a>
</div>



{/* 5*/}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>P. Balakrishnan</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919171542332"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9171542332</a>
</div>


{/* 6 */}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>L. Radha Krishnan</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919360224906"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9360224906</a>
</div>

</div>

<div className='aboutus_directors_container'>

{/* 7 */}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>K. Murugan</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919488793998"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9488793998</a>
</div>


{/* 8 */}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>T. Rajasekara Pandian</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919659716545"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9659716545</a>
</div>

{/* 9*/}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>A. Murugesan</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919715860571"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9715860571</a>
</div>


</div>
<div className='aboutus_directors_container'>

{/* 10 */}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>K. Subramani</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919842208571"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9842208571</a>
</div>



{/* 11 */}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>K. Muthuraj</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919842510486"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9842510486</a>
</div>


{/* 12 */}

<div className='aboutus_director'>
  <div className='aboutus_director_name'>K. Thavamani</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919865274331"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9865274331</a>
</div>

  </div>

  <div className='aboutus_directors_container' style={{justifyContent:'center' }}>
    
<div className='aboutus_director'>
  <div className='aboutus_director_name'>S. Balu</div>
  <div className='aboutus_director_position'>Marketing Team Leader</div>
  <a href="tel:+919865359045"  className="director_number">
  <FontAwesomeIcon icon={faPhoneAlt} className="directors_phone_icon" />
  9865359045</a>
</div>

</div>
      </div>
        <GetDirection />
      <Footer />
    </div>
  )
}

export default Aboutus